<script setup lang="ts">
interface BlocksRendererProps {
  type?: string
}

defineProps<BlocksRendererProps>()

const sectionComponent = new Map([
  ['condition', resolveComponent('LazyArchiveConditions')],
  ['product', resolveComponent('LazyArchiveShop')],
  ['journal', resolveComponent('LazyArchiveNews')],
  ['press', resolveComponent('LazyArchivePress')],
])
</script>

<template>
  <div v-if="type" class="archive">
    <component :is="sectionComponent.get(type)" />
  </div>
</template>
